import React from 'react'
import PropTypes from 'prop-types'
import FilterRemoveButton from '../../FilterRemoveButton'
import Assignee, { getFullNameForAssignee, fromUser } from '../../Assignee'

export const UserItem = ({ user, onDelete }) => {
  let assignment = fromUser(user)
  return <FilterRemoveButton
    filterName={getFullNameForAssignee(assignment)}
    getIcon={
      () =>
        <div style={{ width: '0px', height: '0px', position: 'relative' }}>
          <div className='filter-remove-button__filter-background' />
          <Assignee assignment={assignment} />
        </div>
    }
    onRemove={() => onDelete(user)} />
}

UserItem.propTypes = {
  onDelete: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
}

export default UserItem



// WEBPACK FOOTER //
// ./src/components/BoardFilterButton/FilterList/UserItem.js